module.exports = __webpack_public_path__ + "img/visa-data.a0ccc6fe.svg";